class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  connectedCallback() {
    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    FacetFiltersForm.hideUnsupportedColorFilterSwatches();
    
    // Add real-time image update when color filter changes using event delegation
    const colorFilterChangeHandler = (e) => {
      if (e.target.type === 'checkbox') {
        // Check if it's a color filter
        const filterItem = e.target.closest('.js-filter');
        if (filterItem) {
          const filterLabel = filterItem.querySelector('.facets__label, .mobile-facets__label, .filter__header');
          if (filterLabel) {
            const filterName = filterLabel.textContent.trim().toLowerCase();
            if (filterName.includes('color') || filterName.includes('colour') || 
                filterItem.classList.contains('filterstyle-color')) {
              // Update images immediately when color filter checkbox changes
              FacetFiltersForm.updateProductImagesForColorFilter();
            }
          }
        }
      }
    };
    
    facetForm.addEventListener("change", colorFilterChangeHandler);
    
    // const filterButton = document.querySelector(
    //   ".collection__filter-trigger.wt-filter__trigger.wt-filter__trigger--drawer",
    // );
    // filterButton?.addEventListener("keydown", (e) => {
    //   if (e.key === "Enter" || e.keyCode === 13) {
    //     document.querySelector("collection-section").toggleDrawer();
    //     document
    //       .querySelector(".svg-icon.svg-icon--close.wt-filter__close")
    //       ?.focus();
    //   }
    // });
    // const checkboxInputs = this.querySelectorAll(".form-checkbox__input");
    // checkboxInputs.forEach((input) => {
    //   input.addEventListener("keydown", (e) => {
    //     if (e.key === "Enter" || e.keyCode === 13) {
    //       input.checked = !input.checked;
    //     }
    //   });
    // });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static fireCustomEvent(options) {
    const facetsChange = new CustomEvent("facets:change", {
      bubbles: true,
      cancelable: true,
      detail: {
        desc: "facets changed",
        ...options,
      },
    });
    document.dispatchEvent(facetsChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    // if (countContainer) {
    //   countContainer.classList.add('loading');
    // }
    // if (countContainerDesktop) {
    //   countContainerDesktop.classList.add('loading');
    // }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];


        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.updateProductImagesForColorFilter();
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      })
      .finally(() => FacetFiltersForm.fireCustomEvent());
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.updateProductImagesForColorFilter();
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static hideUnsupportedColorFilterSwatches() {
    const rootStyles = getComputedStyle(document.documentElement);
    document.querySelectorAll("[data-filter-color-variable]").forEach((item) => {
      const variableName = item.dataset.filterColorVariable;
      const input = item.querySelector('input[type="checkbox"]');
      const hasColorVariable =
        variableName && rootStyles.getPropertyValue(`--${variableName}`).trim() !== "";

      item.hidden = !hasColorVariable;
      if (input) input.disabled = !hasColorVariable;
    });
  }

  static updateProductImagesForColorFilter() {
    // Get active color filters from the filter form
    const activeColorFilters = [];
    const filterForm = document.querySelector('facet-filters-form form');
    if (!filterForm) return;

    // Find all checked color filter checkboxes
    const checkedInputs = filterForm.querySelectorAll('input[type="checkbox"]:checked');
    checkedInputs.forEach(input => {
      const filterItem = input.closest('.js-filter');
      if (!filterItem) return;
      
      // Check if this is a color filter by looking at the filter label
      const filterLabel = filterItem.querySelector('.facets__label, .mobile-facets__label, .filter__header');
      if (!filterLabel) return;
      
      const filterName = filterLabel.textContent.trim().toLowerCase();
      // Check if filter name contains color-related keywords
      if (filterName.includes('color') || filterName.includes('colour') || 
          filterItem.classList.contains('filterstyle-color')) {
        const filterValue = input.value || input.closest('label')?.textContent?.trim();
        if (filterValue) {
          activeColorFilters.push({
            value: filterValue.trim(),
            label: filterName
          });
        }
      }
    });

    // If no color filters are active, no need to update images (they show default product image)
    if (activeColorFilters.length === 0) {
      return;
    }

    // Update each product card image based on active color filter using data-color-variants
    const productCards = document.querySelectorAll('.collection__grid__item[data-color-variants]');
    productCards.forEach(card => {
      const colorVariantsData = card.getAttribute('data-color-variants');
      if (!colorVariantsData) return;

      try {
        const colorVariants = JSON.parse(colorVariantsData);
        
        // Find matching variant based on active color filter
        let matchingVariant = null;
        activeColorFilters.forEach(activeFilter => {
          const filterValue = activeFilter.value.trim().toLowerCase();
          
          colorVariants.forEach(variant => {
            if (!variant.variant_image) return;
            
            // Normalize variant value for comparison
            const variantValue = variant.variant_value?.trim().toLowerCase() || '';
            const normalizedVariantValue = variantValue.replace(/_/g, ' ').replace(/-/g, ' ');
            const normalizedFilterValue = filterValue.replace(/_/g, ' ').replace(/-/g, ' ');
            
            // Match color (case-insensitive, handle underscores and hyphens)
            if (variantValue === filterValue || 
                normalizedVariantValue === normalizedFilterValue ||
                variantValue.includes(filterValue) || 
                filterValue.includes(variantValue)) {
              matchingVariant = variant;
            }
          });
        });

        // Update product image if matching variant found
        if (matchingVariant && matchingVariant.variant_image) {
          const img = card.querySelector('.card__img:not(.card__img--hover)');
          const link = card.querySelector('.card__picture a, .card a');
          const titleLink = card.querySelector('.card__title a');

          if (img) {
            // Update image src
            img.setAttribute('src', matchingVariant.variant_image);
            
            // Update srcset for responsive images
            const baseUrl = matchingVariant.variant_image.split('?')[0];
            img.setAttribute('srcset', 
              `${baseUrl}?width=375 375w, ` +
              `${baseUrl}?width=750 750w, ` +
              `${baseUrl}?width=1000 1000w, ` +
              `${baseUrl}?width=1440 1440w`
            );

            // Update product URL with variant ID if available
            if (matchingVariant.variant_id && link) {
              const currentUrl = link.getAttribute('href') || '';
              const urlWithoutVariant = currentUrl.split('?')[0];
              link.setAttribute('href', `${urlWithoutVariant}?variant=${matchingVariant.variant_id}`);
            }

            if (matchingVariant.variant_id && titleLink) {
              const currentUrl = titleLink.getAttribute('href') || '';
              const urlWithoutVariant = currentUrl.split('?')[0];
              titleLink.setAttribute('href', `${urlWithoutVariant}?variant=${matchingVariant.variant_id}`);
            }
          }
        }
      } catch (e) {
        console.error('Error parsing color variants:', e);
      }
    });

    // Also handle color-swatch elements for backward compatibility
    const colorSwatchCards = document.querySelectorAll('color-swatch[data-active-filters]');
    colorSwatchCards.forEach(card => {
      const colorSwatches = card.querySelectorAll('.color-swatcher[data-color]');
      if (!colorSwatches.length) return;

      // Find matching color swatch for active filter
      let matchingSwatch = null;
      activeColorFilters.forEach(activeFilter => {
        colorSwatches.forEach(swatch => {
          const swatchColor = swatch.getAttribute('data-color')?.trim().toLowerCase();
          const filterValue = activeFilter.value.trim().toLowerCase();
          
          // Match color (case-insensitive)
          if (swatchColor === filterValue || 
              swatchColor.includes(filterValue) || 
              filterValue.includes(swatchColor)) {
            matchingSwatch = swatch;
          }
        });
      });

      // Update product image if matching swatch found
      if (matchingSwatch) {
        const img = card.querySelector('.card__img:not(.card__img--hover)');
        const hoverImg = card.querySelector('.card__img--hover');
        const link = card.querySelector('.card__picture a, .card a');
        const titleLink = card.querySelector('.card__title a');

        if (img && matchingSwatch.getAttribute('data-img')) {
          const newImgSrc = matchingSwatch.getAttribute('data-img');
          const newImgSrcset = matchingSwatch.getAttribute('data-srcset');
          const newHref = matchingSwatch.getAttribute('data-href');
          const newHover = matchingSwatch.getAttribute('data-hover');
          const newHoverSrcset = matchingSwatch.getAttribute('data-hover-srcset');

          if (newImgSrc) {
            img.setAttribute('src', newImgSrc);
            if (newImgSrcset) {
              img.setAttribute('srcset', newImgSrcset);
            }
          }

          if (newHref && link) {
            link.setAttribute('href', newHref);
          }

          if (newHref && titleLink) {
            titleLink.setAttribute('href', newHref);
          }

          if (hoverImg && newHover) {
            hoverImg.setAttribute('src', newHover);
            if (newHoverSrcset) {
              hoverImg.setAttribute('srcset', newHoverSrcset);
            }
          }

          // Update active state on swatches
          const swatchWrappers = card.querySelectorAll('.color-swatcher--wrapper');
          swatchWrappers.forEach(wrapper => wrapper.classList.remove('active'));
          matchingSwatch.closest('.color-swatcher--wrapper')?.classList.add('active');

          // Update quick-add buttons if they exist
          const quickAdds = card.querySelectorAll('quick-add');
          const productHandle = matchingSwatch.getAttribute('data-product-handle');
          if (productHandle) {
            quickAdds.forEach(quickAdd => {
              quickAdd.setAttribute('data-product-handle', productHandle);
              const button = quickAdd.querySelector('button');
              if (button && newHref) {
                button.dataset.productUrl = newHref;
              }
            });
          }
        }
      }
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      // const newElement = document.createElement(element.tagName);
      // newElement.innerHTML = element.innerHTML;
      const newElement = element;

      const tabIndexElements = newElement.querySelectorAll(
        ".wt-collapse__trigger",
      );
      tabIndexElements.forEach((el) => el.setAttribute("tabindex", "0"));

      const container = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      );

      container.innerHTML = ""; // clear existing content
      container.appendChild(newElement); // append new element
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );

    FacetFiltersForm.hideUnsupportedColorFilterSwatches();

    // Add event listeners to newly rendered filter inputs for real-time image updates
    // Use event delegation on the form to handle dynamically added inputs
    const filterForms = document.querySelectorAll('facet-filters-form form');
    filterForms.forEach(form => {
      // Remove old listener if exists
      const oldHandler = form._colorFilterChangeHandler;
      if (oldHandler) {
        form.removeEventListener("change", oldHandler);
      }
      
      // Add new listener using event delegation
      const handler = (e) => {
        if (e.target.type === 'checkbox') {
          // Check if it's a color filter
          const filterItem = e.target.closest('.js-filter');
          if (filterItem) {
            const filterLabel = filterItem.querySelector('.facets__label, .mobile-facets__label, .filter__header');
            if (filterLabel) {
              const filterName = filterLabel.textContent.trim().toLowerCase();
              if (filterName.includes('color') || filterName.includes('colour') || 
                  filterItem.classList.contains('filterstyle-color')) {
                FacetFiltersForm.updateProductImagesForColorFilter();
              }
            }
          }
        }
      };
      
      form._colorFilterChangeHandler = handler;
      form.addEventListener("change", handler);
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const q = new URL(location.href).searchParams.get('q'); 
    const formData = new FormData(form);
    if(q && !formData.has('q'))formData.append('q', q);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form")?.id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

// Update product images on initial page load if color filters are active
document.addEventListener('DOMContentLoaded', () => {
  // Wait a bit for filters to be rendered
  setTimeout(() => {
    FacetFiltersForm.hideUnsupportedColorFilterSwatches();
    FacetFiltersForm.updateProductImagesForColorFilter();
  }, 100);
});

// Also update images when filters are rendered (for dynamic content)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      FacetFiltersForm.hideUnsupportedColorFilterSwatches();
      FacetFiltersForm.updateProductImagesForColorFilter();
    }, 200);
  });
} else {
  // DOM already loaded
  setTimeout(() => {
    FacetFiltersForm.hideUnsupportedColorFilterSwatches();
    FacetFiltersForm.updateProductImagesForColorFilter();
  }, 200);
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("input", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value.trim());
    if (minInput.value) maxInput.setAttribute("min", minInput.value.trim());
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const fromInput = this.querySelector('[name="filter.v.price.gte"]');
    const toInput = this.querySelector('[name="filter.v.price.lte"]');
    const sliderEl = this.querySelector(".f-price__slider");

    const globalMax = sliderEl
      ? Number(sliderEl.dataset.max) || 999999
      : 999999;

    let fromValue = parseFloat(fromInput.value) || 0;
    let toValue = parseFloat(toInput.value) || 0;

    if (input.name === "filter.v.price.gte") {
      if (fromValue < 0) {
        fromValue = 0;
      }
      if (fromValue > toValue) {
        fromValue = toValue;
      }
      if (fromValue > globalMax) {
        fromValue = globalMax;
      }
      fromInput.value = fromValue;
    } else {
      if (toValue < fromValue) {
        toValue = fromValue;
      }
      if (toValue > globalMax) {
        toValue = globalMax;
      }
      toInput.value = toValue;
    }
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.closeFilter(event);
      }
    });
    FacetFiltersForm.fireCustomEvent();
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    const priceRanges = document.querySelectorAll(
      ".f-price__inputs > .f-price__val",
    );

    if (
      (event.target.className === "filter__remove" ||
        event.target.parentNode.classList.contains("price_range")) &&
      priceRanges
    ) {
      const priceSlider = document.querySelector(".f-price__slider");

      if (priceSlider) {
        const maxPrice = document
          .querySelectorAll("price-range > div")[0]
          .getAttribute("data-max");
        const currency = document
          .querySelectorAll("price-range > div")[0]
          .getAttribute("data-currency");
        const minPriceRange = priceRanges[0].querySelector("input");
        const maxPriceRange = priceRanges[1].querySelector("input");

        priceSlider.noUiSlider.set([
          priceSlider.dataset.min,
          priceSlider.dataset.max,
        ]);

        minPriceRange.value = 0;
        minPriceRange.max = maxPrice;

        maxPriceRange.value = maxPrice;
        maxPriceRange.min = 0;
      }
    }
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
